import { parseOptionDate } from './optionPricing';
// Count future sessions: exclude today, include expiry if it is a trading weekday.
// This is an estimate until an exchange holiday calendar is supplied.
export function remainingWeekdaySessions(expiry, asOf = new Date(), holidays = []) {
  const end = parseOptionDate(expiry);
  let start;
  if (typeof asOf === 'string') start = parseOptionDate(asOf);
  else if (asOf instanceof Date && Number.isFinite(asOf.getTime())) {
    const parts = new Intl.DateTimeFormat('en-CA', { timeZone:'Asia/Tehran', year:'numeric',month:'2-digit',day:'2-digit' }).formatToParts(asOf);
    const v=Object.fromEntries(parts.map(p=>[p.type,p.value]));start=new Date(Date.UTC(+v.year,+v.month-1,+v.day));
  }
  if (!start || !end) return null;
  const excluded = new Set(holidays);let count=0;
  for(let day=start.getTime()+86400000; day<=end.getTime(); day+=86400000) {
    const date=new Date(day),weekday=date.getUTCDay();
    if(weekday!==4 && weekday!==5 && !excluded.has(date.toISOString().slice(0,10)))count++;
  }
  return count;
}
